<template>
  <div class="container" >
    <div class="col-lg col-md-6 ml-auto mr-auto text-center">
      <div
        v-if="!isMobile()"
        class="card-white card-login-new"
        style="border-radius: 15px; background-color: #ffffff"
      >
        <div class="row">
          <div class="col-lg-7">
            <img
              src="@/assets/img/login2.png"
              style="
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
              "
            />
          </div>
          <div class="col-lg-5">
            <div class="row">
              <div class="col-lg"></div>
              <div class="col-lg-9" style="padding: 100px 10px 10px 10px">
                <p
                  style="
                    color: #4d4d4d;
                    text-align: left;
                    font-size: 34px;
                    font-weight: bold;
                  "
                >
                  Sign In
                </p>
              </div>
              <div class="col-lg"></div>
            </div>
            <div class="row">
              <div class="col-lg"></div>
              <div class="col-lg-9 input-icons">
                <i class="fa fa-user icon"></i>
                <input
                  class="input-field"
                  v-validate="'required'"
                  v-model="model.empid"
                  placeholder="User ID"
                  addon-left-icon="tim-icons icon-single-02"
                />
              </div>
              <div class="col-lg"></div>
            </div>
            <div class="row">
              <div class="col-lg"></div>
              <div class="col-lg-9 input-icons">
                <i class="fa fa-lock icon"></i>
                <input
                  class="input-field"
                  v-validate="'required'"
                   v-model="model.password"
                  placeholder="Password"
                  addon-left-icon="tim-icons icon-single-02"
                  type="password"
                />
              </div>
              <div class="col-lg"></div>

            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg"></div>
              <div class="col-lg-9">
                <button
                  class=" btn-round"
                  style="width: 100%; padding: 10px; background-color: #ff000e; color: #ffffff; outline: none; border:1px solid #FFFFFF;"
                  v-on:click="login()"
                >
                  Sign In
                </button>
                <p style="color: red" v-html="model.message"></p>
            <div class="col-log d-flex justify-content-center text-center;">
              <circle-8 v-if="loading"></circle-8>
            </div>
              </div>
              <div class="col-lg"></div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
      <div
        v-if="isMobile()"
        class="row"
        style="border-radius: 15px; background-color: #ffffff; text-align: center;"
      >
          <div class="outer text-center">
            <img
              src="@/assets/img/AFES Mobile App Login BG with Logo.jpg"
              width="400"
              style="
              
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
              "
            />
          </div>
          <div
            class="inner col-lg"
            style="position: absolute; padding-top: 30%"
          >
            <div class="row">
              <div class="col-lg text-center">
                <h3 style="font-size: 30px; line-height: 5%; color: #ffffff; font-weight: bold;">Welcome back!</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-center">
                <p style="color: #ffffff">
                  You can sign in to access with your
                </p>
                <p class="text-left" style="color: #ffffff; padding-left: 29px;">
                existing account.
                </p>
              </div>
            </div>
          </div>
        <br />
        <div class="row" style="margin: 20px;">
          <div class="col-lg text-left">
            <p
                  style="
                    color: #5d5f5e;
                    text-align: left;
                    font-size: 34px;
                    font-weight: bold;
                  "
                >
                  Sign In
                </p>
          </div>
        </div>
        <div class="row" style="margin: 20px;">
          <div class="col-lg input-icons">
            <i class="fa fa-user icon"></i>
            <input
              class="input-field"
              v-validate="'required'"
              v-model="model.empid"
              placeholder="User ID"
              addon-left-icon="tim-icons icon-single-02"
            />
          </div>
          <div class="col-lg-12 input-icons">
            <i class="fa fa-lock icon"></i>
            <input
              class="input-field"
              v-validate="'required'"
              v-model="model.password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-single-02"
              type="password"
            />
          </div>
          <br />
          <br />
          <br />
          <div class="col-lg-12 text-center">
            <button
              v-if="!loading"
              class="btn-danger btn-round"
              style="width: 100%; padding: 10px"
              v-on:click="login()"
            >
              Sign In
            </button>
            <p style="color: red" v-html="model.message"></p>
            <div class="col-log d-flex justify-content-center text-center">
              <circle-8 v-if="loading"></circle-8>
            </div>
          </div>
        </div>
      
      </div>
      <!-- </form> -->
    </div>
  </div>
</template>
<script>
import { Alert, Checkbox } from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../util/util";
import Card from "../../components/Cards/Card.vue";

export default {
  name: "Login",
  components: {
    Circle8,
    Card,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      checked: true,
      loading: false,
      model: {
        empid: "",
        password: "",
        message: "",
      },
    };
  },
  methods: {
    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      console.log(check);
      return check;
    },
    login() {
      this.loading = true;
      let payload = {
        empid: this.model.empid,
        password: this.model.password,
      };

      // if (navigator.onLine) {
      this.$http
        .post(":9992/auth/staff/login", payload)
        .then((res) => {
          console.log(res);
          this.loading = false;
          if (res.error) {
            //pupout oeror
            console.log(res.message);
            this.model.message = res.message;
          } else {
            //login OK!
            console.log(res.message.jwt_token);
            sessionStorage.setItem("token", res.message.jwt_token);

            //ping goken
            util.tokenPing();

            // GET THE ACCESS MODULE FROM TOKEN
            let access = JSON.parse(
              atob(res.message.jwt_token.split(".")[1])
            ).namespace;

            console.log(access)

            let roles = JSON.parse(
              atob(res.message.jwt_token.split(".")[1])
            ).roles;

            

            // ROUTE USER BASED ON WHAT MODULE IN FIRST ARRAY
            if (roles == "ALLACCESS") {
              this.$router.push("/UserManagement");
            } else {
              if (access[0] == "GREENCARD") {
                this.$router.push("/Greencard/Overview");
              } else if (access[0] == "FLEET") {
                this.$router.push("/Fleet/Overview");
              } else if (access[0] == "INCIDENT") {
                this.$router.push("/IncidentReport/IncidentOverview");
              } else if (access[0] == "CEMS") {
                this.$router.push("/CEMS/Overview");
              } else if (access[0] == "ATTENDANCE") {
                if (roles == "SUPERVISOR") {
                  this.$router.push("Attendance/ScheduleEdit");
                } else {
                  this.$router.push("/Attendance/AttendanceOverview");
                }
              } else if (access[0] == "ASSET") {
                this.$router.push("/Asset/AssetOverview");
              }
            }

            //kne decode and check for acccess domain
          }
        })
        .catch((err) => {
          this.model.message = "Wrong username or password";
          console.log(err);
          // swal({
          //   title: "Wrong employee ID or password!",
          //   type: "error",
          //   confirmButtonClass: "btn btn-success btn-fill",
          //   confirmButtonText: "Okay",
          //   buttonsStyling: false
          // });
        });
      // } else {
      //   swal({
      //     type: "error",
      //     title: "Oops... You have no internet conncetion!"
      //   });
      // }
    },
    loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }

      localStorage.token = req.data.token;
      this.error = false;

      // this.$router.replace(this.$route.query.redirect || "/lightpage");
    },
    loginFailed() {
      this.error = "Login failed!";
      // this.message = res.message;
      delete localStorage.token;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  created() {
    // this.appKey();
    // const loggedIn = sessionStorage.getItem("token");
    // if (loggedIn) {
    //   this.$router.push("/dashboard");
    // }
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.input-icons i {
  position: absolute;
  
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  
}

.icon {
  padding: 15px;
  min-width: 50px;
  text-align: center;
  color: #c7c7c7;
}

.input-field {
  width: 100%;
  padding: 10px;
  padding-left: 40px;
  text-align: left;
  border-radius: 50px;
  border: 1px solid #c7c7c7;
  
  /* color: #e6e6e6; */
}

.input-field:focus{
  outline: none;
  border: 1px solid #00f2c3; 
}

h2 {
  color: green;
}
</style>
